import { computed } from 'vue';
import { useOSettings } from './use-settings';
import { ADMIN_RESOURCES_SETTING_KEY, isAdminResourcesEnabled } from '../utils/admin-resources';

/**
 * Reactive access to the Hub API `admin_resources_enabled` system setting.
 * Missing and invalid values fail open (administration stays available).
 */
export function useAdminResourcesEnabled() {
  const settings = useOSettings();

  const adminResourcesEnabled = computed(() => isAdminResourcesEnabled(settings[ADMIN_RESOURCES_SETTING_KEY]?.value));

  return { adminResourcesEnabled };
}
